import { collect } from 'collect.js';

export function keyLinesByLineNumber(lines) {
    return collect(lines).keyBy('line_number').all();
}

export function keyPackagingByItemNumber(packagingBarcodes) {
    return collect(packagingBarcodes)
        .mapWithKeys((packaging, barcode) => [
            packaging.item_number,
            { ...packaging, barcode },
        ])
        .all();
}

// Weight in grams from the scanned lines and packaging of one collo
export function calculateScansWeight(
    scans,
    linesByLineNumber,
    packagingByItemNumber,
) {
    const line_weight = collect(scans)
        .filter((scan) => scan.data.type === 'line')
        .groupBy('line_number')
        .map((scans) => scans.sum('quantity'))
        .map((quantity, line_number) => {
            return quantity * linesByLineNumber[line_number].weight_per_item;
        })
        .sum();
    const packaging_weight = collect(scans)
        .filter((scan) => scan.data.type === 'packaging')
        .map((scan) => packagingByItemNumber[scan.data.item_number].weight)
        .sum();

    return line_weight + packaging_weight;
}

// A typed weight counts as implausible if it is more than 1 kg and more than 50 % off the calculated weight
export function isImplausibleWeight(weight, calculatedWeight) {
    if (!(weight > 0) || !(calculatedWeight > 0)) {
        return false;
    }

    return (
        Math.abs(weight - calculatedWeight) >
        Math.max(1000, calculatedWeight * 0.5)
    );
}
